import { useEffect, useRef } from 'react';

export default function SustainabilityCTA() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden animate-on-scroll opacity-0 translate-y-8 transition-all duration-1000">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/b3902d691cc8bf2755d5d75abfbf8a0d.jpg"
              alt="持続可能な未来"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/90 via-emerald-800/80 to-emerald-900/90"></div>
          </div>

          <div className="relative z-10 py-20 px-12 text-center text-white">
            <div className="max-w-4xl mx-auto">
              <div className="inline-block px-5 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
                <span className="text-sm font-medium tracking-wide">TOGETHER FOR SUSTAINABILITY</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                持続可能な未来を<br />共に創造しましょう
              </h2>
              <p className="text-xl text-white/90 mb-10 leading-relaxed max-w-3xl mx-auto">
                環境保全と地域発展を両立させる私たちの取り組みに、<br />ぜひご参加ください。
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <a
                  href="/会社概要"
                  className="px-8 py-4 bg-white text-emerald-600 rounded-full font-semibold hover:bg-emerald-50 transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                >
                  会社概要を見る
                </a>
                <a
                  href="/project"
                  className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-full font-semibold hover:bg-white/20 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  プロジェクト詳細
                </a>
              </div>

              <div className="mt-16 grid md:grid-cols-3 gap-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <div className="text-4xl font-bold mb-2">2030</div>
                  <div className="text-white/80">カーボンニュートラル目標年</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <div className="text-4xl font-bold mb-2">100%</div>
                  <div className="text-white/80">再生可能エネルギー化目標</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <div className="text-4xl font-bold mb-2">7</div>
                  <div className="text-white/80">SDGs貢献目標数</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}